import PropTypes from 'prop-types';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Trans } from 'lingui-react';

import Count from './Count';

import RefreshBlockWrapper from './RefreshBlockWrapper';
import RefreshIcon from './RefreshIcon';

function getMessage(type, count) {
  switch (type) {
    case 'asset':
      return <Trans>Assets: {count}</Trans>;
    case 'case':
      return <Trans>Cases: {count}</Trans>;
    case 'search':
      return <Trans>Matches: {count}</Trans>;
    case 'serviceRequest':
      return <Trans>Service Requests: {count}</Trans>;
    default:
      return '';
  }
}

function RefreshBlock({
  count,
  refresh,
  requesting,
  type,
}) {
  const message = getMessage(type, count);

  function renderCount() {
    if (requesting) {
      return null;
    }
    return <Count>{message}</Count>;
  }

  function handleRefreshClick(event) {
    event.preventDefault();
    if (requesting) {
      return null;
    }
    return refresh();
  }

  return (
    <RefreshBlockWrapper id="refresh-block">
      {renderCount()}
      <RefreshIcon
        requesting={requesting}
        onClick={handleRefreshClick}
      >
        <FontAwesome name="refresh" />
      </RefreshIcon>
    </RefreshBlockWrapper>
  );
}

RefreshBlock.propTypes = {
  count: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  refresh: PropTypes.func.isRequired,
  requesting: PropTypes.bool.isRequired,
  type: PropTypes.string,
};

RefreshBlock.defaultProps = {
  count: '-',
  type: undefined,
};

export default RefreshBlock;



// WEBPACK FOOTER //
// ./components/RefreshBlock/index.js